import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, withCtx as _withCtx, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  class: "d-flex align-items-start",
  style: {"width":"calc(100% - 30px - 20px)"}
}
const _hoisted_2 = { class: "row items-center no-wrap" }
const _hoisted_3 = ["disable"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  class: "text-center my-1 mt-2 display-none",
  "data-excelcolspan": "3"
}
const _hoisted_6 = {
  class: "text-center my-1 mt-2 display-none",
  "data-excelcolspan": "3"
}
const _hoisted_7 = {
  key: 0,
  class: "d-flex flex-column align-items-center justify-content-center",
  style: {"position":"absolute","top":"0","left":"0","width":"100%","height":"100%"}
}
const _hoisted_8 = {
  key: 0,
  src: "images/notifications/error.svg",
  alt: "Error",
  style: {"width":"50px","height":"50px"}
}
const _hoisted_9 = {
  class: "mt-2 text-teal",
  style: {"font-size":"1.1em"}
}

import { ref, Ref, computed, watch, onUnmounted, inject } from 'vue';

import UiPopup from '@/ManualApp/Components/Popups/UiPopup.vue';
import PositionsDetailTable from '../table/PositionsDetailTable.vue';
import PositionsChart from '../chart/PositionsChart.vue';
import SpinLoader from '@/App/Components/SpinLoader.vue';

import { getPositionsFromOur } from '../getPositionsFromOur';


export default /*#__PURE__*/_defineComponent({
  __name: 'PositionsDetailPopup',
  props: {
  modelValue: Boolean,
  oid: { type: String, required: true },
  name: { type: String, required: true },
  from: { type: Number, required: true },
  to: { type: Number, required: true },
  paramTitle: { type: String, required: true },
  paramKey: { type: String, required: true },
  nextParamKey: { type: String, required: true },
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props

const html_to_excel_helper = window.html_to_excel_helper;




const getFullDate = inject('getFullDate') as (v: number) => string;

const DB_COLUMNS: { [key: string]: string } = {
  rpms: 'rpm',
  engtmprs: 'engntmpr',
  hydoiltmprs: 'hydroiltmpr',
};

const SCALES: { [key: string]: { [key: string]: (v: number) => boolean } } = {
  rpms: {
    '2001': (v: number): boolean => 2000 < v,
    '2000': (v: number): boolean => 1900 < v && v <= 2000,
    '1900': (v: number): boolean => 1800 < v && v <= 1900,
    '1800': (v: number): boolean => 1700 < v && v <= 1800,
    '1700': (v: number): boolean => 1600 < v && v <= 1700,
    '1600': (v: number): boolean => 1500 < v && v <= 1600,
    '1500': (v: number): boolean => 1400 < v && v <= 1500,
    '1400': (v: number): boolean => 1300 < v && v <= 1400,
    '1300': (v: number): boolean => 1200 < v && v <= 1300,
    '1200': (v: number): boolean => v < 1200,
  },
  engtmprs: {
    '96': (v: number): boolean => 95 < v,
    '95': (v: number): boolean => 86 <= v && v <= 95,
    '85': (v: number): boolean => 61 <= v && v <= 85,
    '60': (v: number): boolean => 41 <= v && v <= 60,
    '40': (v: number): boolean => 1 <= v && v <= 40,
    '0': (v: number): boolean => -20 < v && v <= 0,
    '-20': (v: number): boolean => -30 <= v && v <= -20,
    '-30': (v: number): boolean => v < -30,
  },
  hydoiltmprs: {
    '100': (v: number): boolean => 90 < v && 100 <= v,
    '90': (v: number): boolean => 80 < v && v <= 90,
    '80': (v: number): boolean => 60 < v && v <= 80,
    '60': (v: number): boolean => 50 < v && v <= 60,
    '50': (v: number): boolean => 30 < v && v <= 50,
    '30': (v: number): boolean => v <= 30,
  },
};

const model = computed({
  get: () => props.modelValue,
  set: (show) => emit('update:modelValue', show),
});

const exportToExcelButton: Ref<any> = ref(null);

const positions: Ref<any[]> = ref([]);

const responses: Ref<Map<string, any>> = ref(new Map());

const isRequest = ref(true);
const requestText = ref('');
const requestError = ref(false);

const isDisplayChart = ref(false);

watch(
  () => props.modelValue,
  async (show) => {
    if (show) {
      requestReport();
    }
  },
);

onUnmounted(() => {
  responses.value.clear();
});

function clickOnExportToExcelButton() {
  exportToExcelButton.value.$el.click();
}

const processCallback = (
  state: string,
  label: string,
  color?: string,
  percent?: number | string,
) => {
  requestText.value = label;
  isRequest.value = !(percent && percent === 100);
  if (state === 'error') {
    requestError.value = true;
  }
};

async function requestReport() {
  requestError.value = false;

  const { oid, from, to, paramKey, nextParamKey } = props;

  if (!oid || !from || !to || !paramKey || !nextParamKey) return;

  const key = `${oid}#${from}#${to}#${paramKey}#${nextParamKey}`;

  if (!responses.value.has(key)) {
    isRequest.value = true;
    requestText.value = 'Запрос отправлен...';

    try {
      const data = await requestPositions(oid, from, to);

      if (data && props.modelValue) {
        positions.value = data;
        isRequest.value = false;

        responses.value.set(key, data);
      }
    } catch (error) {
      requestError.value = true;
      requestText.value = 'Произошла ошибка. Попробуйте повторить запрос';
      responses.value.delete(key);
    }
  } else {
    const data = responses.value.get(key);

    if (!data) {
      isRequest.value = true;
      requestError.value = true;
      requestText.value = 'Данные не найдены. Повторите запрос';
      responses.value.delete(key);
      return;
    }

    requestText.value = 'Загружаем данные';
    isRequest.value = true;

    positions.value = data;
    isRequest.value = false;
  }
}

async function requestPositions(
  oid: string | number,
  from: number,
  to: number,
) {
  const interval = { from: props.from, to: props.to };

  const paramColumn: string = DB_COLUMNS[props.paramKey];
  const columns: string[] = ['time', 'dist', 'speed', paramColumn];

  const data = await getPositionsFromOur({
    objId: props.oid,
    processCallback,
    isOnMap: true,
    interval,
    columns,
  });

  if (data) {
    // const positions = data.points.allValues.filter((obj) => {
    //   const scaleFn = SCALES[props.paramKey][props.nextParamKey];
    //   const value = obj[DB_COLUMNS[props.paramKey]];

    //   return scaleFn(value);
    // });

    const positions = data.points.allValues;

    return positions;
  } else {
    return [];
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_unref(model))
      ? (_openBlock(), _createBlock(UiPopup, {
          key: 0,
          onClose: _cache[2] || (_cache[2] = () => (model.value = false)),
          "style-for-body": "padding: 10px; width: 80vw; max-width: 100vw",
          "close-button": "",
          class: "my-popup"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("button", {
                  class: "not-print",
                  style: {"height":"30px"},
                  onClick: _cache[0] || (_cache[0] = 
                (e) =>
                  _unref(html_to_excel_helper).export(
                    e.target,
                    'positions-detail-table',
                    `${props.paramTitle} ${props.name}`,
                    'landscape',
                  )
              ),
                  disable: isDisplayChart.value
                }, " Экспорт в EXCEL ", 8, _hoisted_3),
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isDisplayChart).value = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, isDisplayChart.value]
                  ]),
                  _createTextVNode(" " + _toDisplayString(isDisplayChart.value ? 'Таблица' : 'График'), 1)
                ])
              ]),
              _createElementVNode("div", {
                class: "text-center",
                style: {"width":"calc(100% - 180px - 70px)"},
                innerHTML: 
              `${props.paramTitle} ${props.name}<br>
               за период с ${_unref(getFullDate)(Number(props.from) / 1000)} 
               по ${_unref(getFullDate)(Number(props.to) / 1000)}
              `
            
              }, null, 8, _hoisted_4)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", {
              id: "positions-detail-table",
              style: _normalizeStyle([{"overflow":"scroll","max-height":"80vh"}, { height: isRequest.value ? '100vh' : 'auto' }])
            }, [
              _createElementVNode("h4", _hoisted_5, _toDisplayString(props.paramTitle) + " " + _toDisplayString(props.name), 1),
              _createElementVNode("p", _hoisted_6, " за период с " + _toDisplayString(_unref(getFullDate)(Number(props.from) / 1000)) + " по " + _toDisplayString(_unref(getFullDate)(Number(props.to) / 1000)), 1),
              _withDirectives(_createVNode(PositionsDetailTable, {
                positions: positions.value,
                scales: SCALES,
                "param-key": props.paramKey,
                "next-param-key": props.nextParamKey
              }, null, 8, ["positions", "param-key", "next-param-key"]), [
                [_vShow, !isRequest.value && !isDisplayChart.value]
              ]),
              (_unref(model) && !isRequest.value && isDisplayChart.value)
                ? (_openBlock(), _createBlock(PositionsChart, {
                    key: 0,
                    positions: positions.value,
                    "param-key": props.paramKey,
                    "pos-param-key": DB_COLUMNS[props.paramKey],
                    "next-param-key": props.nextParamKey
                  }, null, 8, ["positions", "param-key", "pos-param-key", "next-param-key"]))
                : _createCommentVNode("", true)
            ], 4),
            (isRequest.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", null, [
                    (requestError.value)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                      : _createCommentVNode("", true),
                    (!requestError.value)
                      ? (_openBlock(), _createBlock(SpinLoader, {
                          key: 1,
                          width: 50,
                          height: 50
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(requestText.value), 1),
                  (requestError.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-primary mt-2",
                        onClick: requestReport
                      }, " Повторить запрос "))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})